import React, { useEffect, useState } from "react";
import SelectInput from "../ui/SelectInput";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { MdClose, MdDocumentScanner, MdOutlineWarning } from "react-icons/md";
import InputText from "../ui/InputText";
import Datepicker from "react-tailwindcss-datepicker";
import { FaCheckCircle, FaDollarSign } from "react-icons/fa";
import { toast } from "react-toastify";
import { Button, CircularProgress } from "@mui/material";
import ActualizarHistorialPagosCotizaciones from "../../utils/automateFuncions/ActualizarHistorialPagosCotizaciones"
import { useSelector } from "react-redux";

const AgregarPago = ({
  open,
  onClose,
  idCotizacion,
  precioTotal,
  setPagosList,
  pagosList,
  moneda,
}) => {

  const user = useSelector((state) => state.auth.user);

  const [isLoading, setIsLoading] = useState(false);

  const [formValues, setFormValues] = useState({
    descripcion: "",
    percentage: 0,
    precio: 0,
    fechaLimite: {
      startDate: null,
      endDate: null,
    },
  });

  const registerServicio = async (event) => {
    event.preventDefault();
    
    try {
      setIsLoading(true);
      const { data } = await axios.post(`${BACKEND}/api/pagosCotizaciones`, {
        cotizacion: idCotizacion,
        descripcion: formValues.descripcion,
        precio: formValues.precio,
        percentage: (formValues.precio / precioTotal.totalConIGV) * 100,
        fechaLimite: formValues.fechaLimite.startDate,
      }, {withCredentials: true});

      ActualizarHistorialPagosCotizaciones({
        idCotizacion: idCotizacion, 
        idPago: data.doc.id, 
        tipoEvento: "Pago añadido",
        idUsuario: user.id
      });

      setPagosList([...pagosList, data.doc]);
      onClose();
      
      setFormValues({
        descripcion: "",
        percentage: 0,
        precio: 0,
        fechaLimite: {
          startDate: null,
          endDate: null,
        },
      });

      toast.success("Pago registrado correctamente");

    } catch (error) {
      toast.error("Error al registrar el pago");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mb-3">
      {open && (
        <form
          onSubmit={registerServicio}
          className="max-w-2xl mx-auto bg-gray-100 p-4 shadow-lg rounded-md my-6"
        >
          <div className=" flex justify-end">
            <div
              onClick={() => onClose()}
              className="cursor-pointer border border-gray-300 bg-gray-300 hover:bg-gray-400 transiton-all duration-100 p-2 rounded-md"
            >
              <MdClose className="text-black" />
            </div>
          </div>
          
          <div className=" ">
            <h3 className="text-center text-sm font-bold">Nuevo Pago</h3>
          </div>

          <SelectInput
            title={"Concepto"}
            value={formValues.descripcion}
            setValue={(e) =>
              setFormValues((prev) => ({ ...prev, descripcion: e }))
            }
            options={[
              { id: 1, value: "1° pago", label: "1° pago" },
              { id: 2, value: "2° pago", label: "2° pago" },
              { id: 3, value: "3° pago", label: "3° pago" },
              { id: 4, value: "4° pago", label: "4° pago" },
              { id: 5, value: "5° pago", label: "5° pago" },
              { id: 6, value: "6° pago", label: "6° pago" },
              { id: 7, value: "7° pago", label: "7° pago" },
              { id: 8, value: "8° pago", label: "8° pago" },
              { id: 9, value: "9° pago", label: "9° pago" },
              { id: 10, value: "10° pago", label: "10° pago" },
              { id: 11, value: "11° pago", label: "11° pago" },
              { id: 12, value: "12° pago", label: "12° pago" },
              { id: 13, value: "13° pago", label: "13° pago" },
              { id: 14, value: "14° pago", label: "14° pago" },
              { id: 15, value: "15° pago", label: "15° pago" },
              { id: 16, value: "16° pago", label: "16° pago" },
              { id: 17, value: "17° pago", label: "17° pago" },
              { id: 18, value: "18° pago", label: "18° pago" },
              { id: 19, value: "19° pago", label: "19° pago" },
              { id: 20, value: "20° pago", label: "20° pago" },
            ]}
          />

          <div className="my-3">
            <label
              htmlFor={"percentage"}
              class="block mb-2 text-xs font-medium text-gray-900 dark:text-white"
            >
              {/* Porcentaje de pago */}
              Monto del pago
            </label>
            <input
              type="number"
              value={formValues.precio}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  precio: Number(e.target.value),
                }))
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 "
              placeholder={""}
              required
            />
          </div>

          <div className="mt-3">
            <div>
              <label
                htmlFor={"fechaInicio"}
                class="block mb-1 text-xs font-medium text-gray-900 "
              >
                Fecha limite
              </label>
              <input 
                type="date"
                placeholder="Fecha límite"
                value={formValues.fechaLimite?.startDate || ''} // Manejo de valores nulos/undefined
                className="bg-gray-50 py-2 px-4 border border-gray-300 focus:outline-none w-full rounded-md text-xs"
                onChange={(e) => 
                  setFormValues((prev) => ({
                    ...prev,
                    fechaLimite: {
                      ...prev.fechaLimite, // Mantener otros valores dentro de fechaInicio
                      startDate: e.target.value, // Actualizar startDate
                      endDate: e.target.value,   // Sincronizar endDate
                    },
                  }))
                }
              />
            </div>
          </div>

          <div className=" bg-gray-300 h-[1px] w-full my-4"></div>

          <div className="flex justify-between text-xs">
            <span>{((formValues.precio / precioTotal) * 100).toFixed(2)}  %</span>
            <span>{moneda === "PEN" ? "S/" : "$"} {formValues.precio.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2            
            })}</span>
          </div>

          <div className="my-6 flex justify-center gap-4">
            <Button
              variant="contained"
              type="submit"
              disabled={isLoading}
              endIcon={isLoading ? <CircularProgress size={14} className="animate-spin" /> : <FaDollarSign size={14} />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins", 
                padding: "8px 24px",
                backgroundColor: "#2563eb",
                textTransform: "none",
                borderRadius: "8px",
                width: "180px",
                '&:hover': {
                  backgroundColor: "#1d4ed8",
                }
              }}
            >
              Registrar
            </Button>
          </div>

        </form>
      )}

     
    </div>
  );
};

export default AgregarPago;
